/** @format */

import { Box, IconButton } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { API_ROUTES } from "../../utils/apiConfig/apiRoutes";
import { DOMAIN_NAME } from "../../utils/config";
import { getCookie } from "../../utils/cookies";

import { removeWhiteSpace } from "../../utils/DateAndFormat";

import AccessLogo from "../../assets/image/Access.png";
import PXLogo from "../../assets/image/PX.png";
import CampaignsLogo from "../../assets/image/campaign.png";
import ListingLogo from "../../assets/image/listings.png";
import ReputationLogo from "../../assets/image/reputaton.png";
import SetterLogo from "../../assets/image/setter-layline.png";
import AccessSvg from "../../assets/svg/AccessSvg";
import CampaignsMsgSvg from "../../assets/svg/CampaignMsgSvg";
import ListingSvg from "../../assets/svg/ListingSvg";
import PXSvg from "../../assets/svg/PXSvg";
import ReputationSvg from "../../assets/svg/ReputationSvg";
import SetterSvg from "../../assets/svg/SetterSvg";
import { responsiveDimension } from "../../config/responsiveDimension";
import AutocompleteClient from "./AutoComplete";
import { useLocation } from "react-router-dom";

const AdminLayout = ({ handleChange = () => null }) => {
  const clientBrands = useSelector((state) => state.user.clientBrands);

  const permission = useSelector((state) => state.campaign.permission);
  const location = useLocation().state;

  // const roles = [{ name: "minnesotaurology" }];

  const [roles, setRoles] = useState([]);
  // const fetchClientBrand = async () => {
  //   try {
  //     const response = await apiGet(API_ROUTES.GET_CLIENTBRAND);
  //     const value = response?.clientBrands;
  //     if (value?.length) {
  //       const sortedValue = [...value]?.sort((a, b) =>
  //         a?.ClientBrandName?.localeCompare(b?.ClientBrandName)
  //       );
  //       setRoles(sortedValue);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const fetchClientBrand = async () => {
    try {
      // const response = await apiGet(API_ROUTES.GET_CLIENTBRAND);
      const response = await axios.get(API_ROUTES.GET_CLIENTBRAND, {
        headers: {
          authorization: `Bearer ${getCookie("ssoToken") || location?.token}`,
        },
      });
      const value = response?.data?.data || [];
      const usr = window?.history?.state?.usr;
      console.log(usr, "usr");
      if (usr) usr.token = undefined;
      const sortedValue = [...value]?.sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setRoles(sortedValue);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchClientBrand();
  }, []);

  const handleUrlStatus = (str) => {
    const findStatus = permission?.find((v) =>
      removeWhiteSpace(v?.mainMenu)?.includes(removeWhiteSpace(str))
    )?.status;
    return findStatus === undefined ? true : findStatus;
  };

  const listIcons = [
    {
      img: PXLogo,
      w: 35,
      h: 35,
      link: DOMAIN_NAME?.patientExperience,
      imgUrl:
        "https://stage.layline.live/img/newIcons/headIcon/patientExp-head.svg",
      // status: handleUrlStatus("Patient Experience"),
      status: true,
      icon: <PXSvg />,
    },
    {
      img: ReputationLogo,
      w: 35,
      h: 35,
      link: DOMAIN_NAME?.reputation,
      imgUrl:
        "https://stage.layline.live/img/newIcons/headIcon/reputaton-head.svg",
      // status: handleUrlStatus("Reputation"),
      status: true,
      icon: <ReputationSvg />,
    },
    {
      img: ListingLogo,
      w: 35,
      h: 35,
      link: DOMAIN_NAME?.listing,
      imgUrl:
        "https://stage.layline.live/img/newIcons/headIcon/listings-head.svg",
      // status: handleUrlStatus("Listings"),
      status: true,
      icon: <ListingSvg />,
    },
    {
      img: SetterLogo,
      w: 35,
      h: 35,
      link: DOMAIN_NAME?.setter,
      imgUrl:
        "https://stage.layline.live/img/newIcons/headIcon/setter-head.svg",
      // status: handleUrlStatus("setter"),
      status: true,
      icon: <SetterSvg />,
    },
    {
      img: CampaignsLogo,
      w: 37,
      h: 37,
      link: DOMAIN_NAME?.campaign,
      imgUrl:
        "https://stage.layline.live/img/newIcons/headIcon/campaign-head.svg",
      // status: handleUrlStatus("Campaigns"),
      status: true,
      icon: <CampaignsMsgSvg />,
    },
    {
      img: AccessLogo,
      w: 19,
      h: 19,
      link: DOMAIN_NAME?.access,
      imgUrl: "https://stage.layline.live/img/newIcons/accessIcon.svg",
      // status: handleUrlStatus("Access"),
      status: true,
      icon: <AccessSvg />,
    },
  ];

  return (
    <>
      {true && (
        <Box
          display="flex"
          justifyContent="flex-end"
          sx={{
            backgroundColor: "#1e2a4f",
            padding: "0.53rem 1.3rem ",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {listIcons.map(
            (item, index) =>
              item?.status && (
                <IconButton
                  key={index}
                  LinkComponent={"a"}
                  href={item.link}
                  target="_blank"
                  sx={{
                    p: 0,
                  }}
                >
                  <img src={item?.imgUrl} width={item?.w} height={item?.h} />
                  {/* {item?.icon} */}
                </IconButton>
              )
          )}
          <Box
            sx={{
              width: responsiveDimension("60%", "60%", "30%", "15%", "15%"),
              bgcolor: "white",
              borderRadius: "0.2rem",
            }}
          >
            <AutocompleteClient
              placeholder="Select Client"
              data={roles}
              accessorKey={"name"}
              value={clientBrands}
              handleChange={handleChange}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default AdminLayout;
